/* Ronrón · interacciones propias (prefijo mt-) */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    (root || document).querySelectorAll('.mt-reveal, [data-mt-observar]').forEach(function (el) {
      if (el.dataset.mtRev) return; el.dataset.mtRev = '1';
      if (!io || reduce) el.classList.add('mt-visible'); else io.observe(el);
    });
  }

  function initHero(root) {
    (root || document).querySelectorAll('[data-mt-hero]').forEach(function (h) {
      if (h.dataset.mtInit) return; h.dataset.mtInit = '1';
      var img = h.querySelector('.mt-hero__media img');
      var go = function () { requestAnimationFrame(function () { h.classList.add('mt-listo'); }); };
      if (reduce || !img || img.complete) go(); else { img.addEventListener('load', go); setTimeout(go, 1500); }
    });
  }

  function initHotspots(root) {
    (root || document).querySelectorAll('[data-mt-hotspots]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var puntos = sec.querySelectorAll('.mt-hs__punto');
      var movil = sec.querySelector('.mt-hs__movil');
      function abrir(p) {
        puntos.forEach(function (x) { x.classList.toggle('mt-abierto', x === p); x.querySelector('button').setAttribute('aria-expanded', x === p ? 'true' : 'false'); });
        if (movil && p) movil.innerHTML = p.querySelector('.mt-hs__tarjeta').innerHTML;
      }
      puntos.forEach(function (p) {
        var b = p.querySelector('button');
        b.addEventListener('click', function (ev) { ev.stopPropagation(); abrir(p.classList.contains('mt-abierto') && window.innerWidth > 749 ? null : p); });
        p.addEventListener('mouseenter', function () { if (window.innerWidth > 749) abrir(p); });
      });
      sec.addEventListener('mouseleave', function () { if (window.innerWidth > 749) abrir(null); });
      if (puntos[0] && movil) movil.innerHTML = puntos[0].querySelector('.mt-hs__tarjeta').innerHTML;
      if (puntos[0] && window.innerWidth <= 749) abrir(puntos[0]);
    });
  }

  function initComparador(root) {
    (root || document).querySelectorAll('[data-mt-comparador]').forEach(function (c) {
      if (c.dataset.mtInit) return; c.dataset.mtInit = '1';
      var btn = c.querySelector('button');
      var pos = parseFloat(c.getAttribute('data-inicio')) || 50;
      var arrastrando = false;
      function set(p) { pos = Math.max(0, Math.min(100, p)); c.style.setProperty('--pos', pos + '%'); if (btn) btn.setAttribute('aria-valuenow', Math.round(pos)); }
      function desde(ev) { var r = c.getBoundingClientRect(); var x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - r.left; set(x / r.width * 100); }
      c.addEventListener('pointerdown', function (ev) { arrastrando = true; desde(ev); c.setPointerCapture && c.setPointerCapture(ev.pointerId); });
      c.addEventListener('pointermove', function (ev) { if (arrastrando) desde(ev); });
      c.addEventListener('pointerup', function () { arrastrando = false; });
      c.addEventListener('pointercancel', function () { arrastrando = false; });
      if (btn) btn.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowLeft') { set(pos - 5); ev.preventDefault(); }
        if (ev.key === 'ArrowRight') { set(pos + 5); ev.preventDefault(); }
      });
      set(pos);
      // pequeña demostración al entrar en pantalla
      if (!reduce && 'IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return; o.disconnect();
          var t0 = null, base = pos;
          function paso(t) { if (!t0) t0 = t; var k = (t - t0) / 1600; if (k > 1 || arrastrando) return; set(base + Math.sin(k * Math.PI * 2) * 18); requestAnimationFrame(paso); }
          setTimeout(function () { requestAnimationFrame(paso); }, 400);
        }, { threshold: .5 });
        o.observe(c);
      }
    });
  }

  function initFrase(root) {
    (root || document).querySelectorAll('[data-mt-frase]').forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = '1';
      var pals = el.querySelectorAll('.mt-pal');
      if (reduce || !pals.length) { pals.forEach(function (p) { p.classList.add('mt-on'); }); return; }
      function actualizar() {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var prog = (vh * 0.85 - r.top) / (r.height + vh * 0.45);
        prog = Math.max(0, Math.min(1, prog));
        var n = Math.round(prog * pals.length);
        pals.forEach(function (p, i) { p.classList.toggle('mt-on', i < n); });
      }
      window.addEventListener('scroll', actualizar, { passive: true });
      window.addEventListener('resize', actualizar);
      actualizar();
    });
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var datos = sec.querySelector('[data-mt-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var form = sec.querySelector('form[action*="/cart/add"]');
      var inputId = sec.querySelector('input[name="id"]');
      var precio = sec.querySelectorAll('[data-mt-precio]');
      var tachado = sec.querySelectorAll('[data-mt-tachado]');
      var btn = sec.querySelector('[data-mt-anadir]');
      var btnTxt = btn ? btn.querySelector('span') : null;
      var txtOk = btn ? btn.getAttribute('data-txt') : '';
      var txtAgotado = btn ? btn.getAttribute('data-agotado') : '';
      var principal = sec.querySelector('[data-mt-principal]');
      var minis = sec.querySelectorAll('.mt-prod__mini');
      var aviso = sec.querySelector('.mt-prod__aviso');
      var moneda = sec.getAttribute('data-moneda') || 'EUR';
      var locale = document.documentElement.lang || 'es';

      function dinero(c) {
        try { return new Intl.NumberFormat(locale, { style: 'currency', currency: moneda }).format(c / 100); }
        catch (e) { return (c / 100).toFixed(2) + ' ' + moneda; }
      }
      function verImagen(src, srcset, idx) {
        if (!principal || !src) return;
        principal.style.opacity = '0.3';
        var tmp = new Image();
        tmp.onload = function () { principal.src = src; if (srcset) principal.srcset = srcset; else principal.removeAttribute('srcset'); principal.style.opacity = '1'; };
        tmp.src = src;
        minis.forEach(function (m, i) { m.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      }
      minis.forEach(function (m, i) {
        m.addEventListener('click', function () { verImagen(m.getAttribute('data-src'), m.getAttribute('data-srcset'), i); });
      });

      function actualizar() {
        if (!variantes.length) return;
        var sel = [];
        sec.querySelectorAll('.mt-opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
          var lbl = fs.querySelector('legend span');
          if (lbl && c) lbl.textContent = c.value;
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { if (btn) { btn.disabled = true; btnTxt.textContent = txtAgotado; } return; }
        inputId.value = v.id;
        precio.forEach(function (p) { p.textContent = dinero(v.price); });
        tachado.forEach(function (t) {
          if (v.compare_at_price && v.compare_at_price > v.price) { t.textContent = dinero(v.compare_at_price); t.hidden = false; } else t.hidden = true;
        });
        if (btn) { btn.disabled = !v.available; btnTxt.textContent = v.available ? txtOk : txtAgotado; }
        if (v.featured_media) {
          var idx = -1;
          minis.forEach(function (m, i) { if (m.getAttribute('data-media-id') == v.featured_media.id) idx = i; });
          if (idx > -1) verImagen(minis[idx].getAttribute('data-src'), minis[idx].getAttribute('data-srcset'), idx);
          else if (v.featured_media.src) verImagen(v.featured_media.src, null, -1);
        }
        if (window.history && window.history.replaceState && sec.hasAttribute('data-url')) {
          window.history.replaceState({}, '', sec.getAttribute('data-url') + '?variant=' + v.id);
        }
      }
      sec.querySelectorAll('.mt-opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cant = sec.querySelector('.mt-cantidad input');
      sec.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () { cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-mt-cant'), 10)); });
      });

      if (form) {
        form.addEventListener('submit', function (ev) {
          if (!window.fetch) return;
          ev.preventDefault();
          if (btn) btn.disabled = true;
          var cartDrawer = document.querySelector('cart-drawer');
          var cartNotif = document.querySelector('cart-notification');
          var fd = new FormData(form);
          var secciones = [];
          if (cartDrawer && cartDrawer.getSectionsToRender) secciones = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
          else if (cartNotif && cartNotif.getSectionsToRender) secciones = cartNotif.getSectionsToRender().map(function (s) { return s.id; });
          if (secciones.length) { fd.append('sections', secciones.join(',')); fd.append('sections_url', window.location.pathname); }
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (btn) btn.disabled = false;
            if (res.status) { if (aviso) aviso.textContent = res.description || res.message; return; }
            if (aviso) aviso.textContent = '';
            var ui = cartDrawer || cartNotif;
            if (ui && ui.renderContents && res.sections) {
              if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
              ui.renderContents(res);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          }).catch(function () { form.submit(); });
        });
      }

      var barra = sec.querySelector('.mt-barra');
      if (barra && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          barra.classList.toggle('mt-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(btn);
        barra.querySelector('button').addEventListener('click', function () { btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); });
      }
    });
  }

  function initTodo(root) {
    initReveals(root); initHero(root); initHotspots(root); initComparador(root); initFrase(root); initProducto(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  else initTodo(document);
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
